export default __webpack_public_path__ + "img/1f994dc92263b08b87a6f863401a3063.png";